import { forEachForm } from "./core/";
import { addRestructureObserver } from "./core/restructure";
import { addFieldFilled } from "./fieldFilled";
import { addTextCounter } from "./textCounter";
import { addForceRequired } from "./forceRequired";
import { addPopoverRange } from "./popoverRange";
import { addDataLoading } from "./dataLoad";
import { addDependsOn } from "./dependsOn";
import { addMultiStep } from "./multiStep";
import { addTogether } from "./together";
import { addIntegerValidation, addPhoneValidation, addPositiveValidation, addTextCounterValidation } from "./validation";
import { addEdited } from "./edited";

export * from "./core/restructure";
export * from "./fieldFilled";
export * from "./forceRequired";
export * from "./textCounter";
export * from "./popoverRange";
export * from "./dataLoad";
export * from "./dependsOn";
export * from "./validation";

/**
 * @type {Record<string, (((form: HTMLFormElement) => void)|((form: HTMLFormElement) => void)[])>}
 */
export const defaultFormPluginMap = {
  "forceRequired": addForceRequired,
  "fieldFilled": addFieldFilled,
  "textCounter": addTextCounter,
  "popoverRange": addPopoverRange,
  "dataLoading": addDataLoading,
  "dependsOn": addDependsOn,
  "multiStep": addMultiStep,
  "together": addTogether,
  "edited": addEdited,
  "validation": [
    addIntegerValidation,
    addPhoneValidation,
    addPositiveValidation,
    addTextCounterValidation,
  ]
}

/**
 * @param {string|null} [formSelector=null] Defaults to `baylorFormClass`.
 * @param {Record<string, (((form: HTMLFormElement) => void)|((form: HTMLFormElement) => void)[])>|null} [pluginMap=null] Defaults to `defaultPluginMap`.
 */
export function initForms(formSelector = null, pluginMap = null) {
  /** @type {HTMLFormElement[]} */
  const forms = [];
  const base = "data-bu-form";
  const formPluginMap = pluginMap ?? defaultFormPluginMap;

  forEachForm(form => {
    forms.push(form);

    /**
     * @param {(((form: HTMLFormElement) => void)|((form: HTMLFormElement) => void)[])} f 
     */
    const run = (f) => {
      if (Array.isArray(f)) {
        for (const f2 of f) {
          f2(form);
        }
      } else {
        f(form);
      }
    }

    const value = form.getAttribute(base);
    if (value === "true" || value === "all" || !value) {
      for (const f of Object.values(formPluginMap)) {
        run(f);
      }
    } else {
      const keys = value.split(',').map(s => s.trim());
      for (const k of keys) {
        const plugins = formPluginMap[k];
        if (typeof(plugins) === "undefined") continue;
        run(plugins);
      }
    }
  }, formSelector);

  for (const form of forms) {
    // Run this last, so that it triggers "restructure" events after things have a chance to attach listeners.
    addRestructureObserver(form);
  }
}